import React, { useEffect, useState } from "react";
import { basicColumns } from "./column";
import { ActionIcon } from "rizzui/action-icon";
import { Text } from "rizzui/typography";
import { useNavigate } from "react-router";
import BlankPage from "./blank";
import MyLoader from "../../component/loader";
import DataTable from "../../component/table";
import useFetchData from "../../hooks/useFetchData";

export const orderData = [
  {
    id: "3413",
    project: "Boluwatife",
    assistant: "Liam",
    dateCreated: "25 Dec, 25 | 08:45AM",
    description:
      "This is just a description of the said project to give the user some context",
    leads: "5984",
    status: "active",
  },
  {
    id: "3413",
    project: "Boluwatife",
    assistant: "Liam",
    dateCreated: "25 Dec, 25 | 08:45AM",
    description:
      "This is just a description of the said project to give the user some context",
    leads: "5984",
    status: "active",
  },
  {
    id: "3413",
    project: "Boluwatife",
    assistant: "Liam",
    dateCreated: "25 Dec, 25 | 08:45AM",
    description:
      "This is just a description of the said project to give the user some context",
    leads: "5984",
    status: "active",
  },
  {
    id: "3413",
    project: "Boluwatife",
    assistant: "Liam",
    dateCreated: "25 Dec, 25 | 08:45AM",
    description:
      "This is just a description of the said project to give the user some context",
    leads: "5984",
    status: "active",
  },
  {
    id: "3413",
    project: "Boluwatife",
    assistant: "Liam",
    dateCreated: "25 Dec, 25 | 08:45AM",
    description:
      "This is just a description of the said project to give the user some context",
    leads: "5984",
    status: "active",
  },
  {
    id: "3413",
    project: "Boluwatife",
    assistant: "Liam",
    dateCreated: "25 Dec, 25 | 08:45AM",
    description:
      "This is just a description of the said project to give the user some context",
    leads: "5984",
    status: "active",
  },
  {
    id: "3413",
    project: "Boluwatife",
    assistant: "Liam",
    dateCreated: "25 Dec, 25 | 08:45AM",
    description:
      "This is just a description of the said project to give the user some context",
    leads: "5984",
    status: "not active",
  },
  {
    id: "3413",
    project: "Boluwatife",
    assistant: "Liam",
    dateCreated: "25 Dec, 25 | 08:45AM",
    description:
      "This is just a description of the said project to give the user some context",
    leads: "5984",
    status: "not active",
  },
  {
    id: "3413",
    project: "Boluwatife",
    assistant: "Liam",
    dateCreated: "25 Dec, 25 | 08:45AM",
    description:
      "This is just a description of the said project to give the user some context",
    leads: "5984",
    status: "active",
  },
];

export default function Projects() {
  useEffect(() => {
    document.title = "Campaigns";
  }, []);
  const navigate = useNavigate();

  const [page, setPage] = useState(1);

  const { data, error, isLoading, loading } = useFetchData({
    dataType: "campaigns",
    page: page,
  });

  if (loading && !error) return <MyLoader />;
  else if (error)
    return (
      <Text className="font-switzer text-[14px] text-center my-auto">
        {error?.message}
      </Text>
    );
  else
    return data?.data?.length > 0 ? (
      <div className="w-full">
        <div className="justify-end flex gap-4 w-full">
          <ActionIcon
            variant="text"
            className="h-[34px] w-[180px] rounded-[4px] border-[.5px] border-muted py-[10px] px-[16px] gap-[4px] bg-btn mb-[22px] hover:text-background text-background"
            onClick={() => navigate("/campaigns/new")}
          >
            <Text className="font-[400] font-gilroyMedium text-[12px] leading-[14.56px]">
              Create new campaign
            </Text>
          </ActionIcon>
        </div>
        <DataTable
          data={data?.data ?? []}
          columns={basicColumns}
          pageSize={data?.metadata?.pagination?.totalPages}
          setPage={setPage}
          isLoading={isLoading}
          error={error}
          meta={(row) => navigate("/campaigns/" + row.original?._id)}
          defaultSort={{ id: "dateCreated", desc: true }}
        />
      </div>
    ) : (
      <BlankPage />
    );
}
